import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link2, Loader2, Activity } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const IntegrationAnalysis = ({ project }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [project.id]);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${API}/projects/${project.id}/discovery/integrations`);
      setData(response.data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !data) return <Loader2 className="w-12 h-12 animate-spin mx-auto mt-20" />;

  const typeColors = {
    'REST API': 'blue',
    'SOAP': 'purple',
    'File Interface': 'green',
    'RFC/BAPI': 'orange',
    'IDoc': 'pink',
    'OData': 'cyan'
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
      <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
        <Link2 className="w-6 h-6 mr-3 text-cyan-600" />
        External System Integrations
      </h3>
      
      <div className="grid md:grid-cols-6 gap-4 mb-8">
        {Object.entries(data.by_type).map(([type, count]) => (
          <div key={type} className="bg-gray-50 border-2 border-gray-200 rounded-xl p-3 text-center">
            <p className="text-xs text-gray-600 font-medium mb-1 capitalize">{type.replace('_', ' ')}</p>
            <p className="text-2xl font-bold text-gray-900">{count}</p>
          </div>
        ))}
      </div>

      <div className="space-y-4">
        {data.integrations.map((integration, idx) => {
          const color = typeColors[integration.type] || 'gray';
          return (
            <div key={idx} className={`border-2 border-${color}-200 bg-${color}-50 rounded-xl p-5`}>
              <div className="flex items-start justify-between">
                <div>
                  <p className="text-lg font-bold text-gray-900 mb-1">{integration.system}</p>
                  <div className="flex items-center space-x-4 text-sm">
                    <span className={`px-3 py-1 bg-white rounded-lg font-semibold text-${color}-700`}>
                      {integration.type}
                    </span>
                    <span className="text-gray-600">Frequency: <span className="font-bold text-gray-900">{integration.frequency}</span></span>
                  </div>
                </div>
                <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                  integration.status === 'Active' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
                }`}>
                  <Activity className="w-3 h-3 inline mr-1" />
                  {integration.status}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
